export const fonts = {
  BentonSansMedium: 'BentonSansMedium',
  BentonSansRegular: 'BentonSansRegular',
  BentonSansCompressedBold: 'BentonSansCompressedBold',
  BentonSansCondensedBold: 'BentonSansCondensedBold',
};
